import { Link, useLocation, useNavigate } from "react-router-dom";
import { useHandleNavClickCommunityPage, } from "../../hooks/useHandleNavClick";
// import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      ease: "easeInOut",
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const popIn = {
  hidden: { opacity: 0, scale: 0.85 },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      damping: 14,
      stiffness: 60,
      mass: 0.5,
    },
  },
};

export default function HeroSection() {

  const handleNavClick = useHandleNavClickCommunityPage();

  return (
    <section
      initial="hidden"
      animate="show"
      className="p-4 bg-secondary pb-[10rem] text-black rounded-2xl lg:min-h-screen"
    >
      <div
        variants={container}
        className="container grid max-w-7xl place-items-center items-stretch gap-8 lg:h-[80vh] lg:grid-cols-2"
      >
        {/* LEFT CONTENT */}
        <div className="relative flex flex-col items-center justify-center h-full gap-4 lg:gap-6">
          <img
            variants={popIn}
            src="/images/jigsaw.png"
            alt=""
            className="w-16 h-16 ml-4 sm:ml-6 xl:ml-36"
          />
          <img
            variants={popIn}
            transition={{ delay: 0.3 }}
            src="/images/medal.png"
            alt=""
            className="w-16 h-16 absolute top-[85%] right-0 xl:-mt-12 "
          />

          <h1
            variants={item}
            className="font-bold text-[clamp(2.25rem,1.893rem+1.786vw,4.5rem)] leading-[1.3]"
          >
            A <span className="text-primary">Community</span> for Developers,
            Designers, Creators, Writers...
          </h1>

          <p variants={item}>
            Looking to join a community? Enjoy exclusive hangouts, exciting
            trips, dynamic chat, invaluable resource sharing, and transformative
            personal development.
          </p>

          {/* Avatars */}
          <div variants={item} className="flex items-center">
            {["hero-image-1", "hero-image-2", "hero-image-6", "hero-image-4", "hero-image-3"].map(
              (img, idx) => (
                <img
                  key={img}
                  src={`/images/${img}.jpg`}
                  alt="member of community"
                  loading="lazy"
                  className={`h-[3.25rem] w-[3.25rem] rounded-full ${idx !== 0 ? "-ml-1" : ""
                    }`}
                />
              )
            )}
            <div className="grid py-3 px-1 -ml-1 font-bold border-4 border-primary rounded-full text-[13px] text-primary place-items-center">
              500+
            </div>
          </div>

          {/* Desktop CTAs */}
          <div
            variants={item}
            className="hidden lg:flex gap-4 justify-center  *:bg-primary *:rounded-full *:py-3 *:hover:opacity-90 *:text-secondary"
          >

            <Link to='https://chat.whatsapp.com/GGDf21NCgcfA5R5z3hRBrv' className="px-10 xl:px-16 bg-primary text-secondary rounded-full py-3 hover:opacity-90">
              Join the Community
            </Link>

            <button
              onClick={() => handleNavClick("/#hireUs")}
              className="px-10 xl:px-16 bg-primary text-secondary rounded-full py-3 hover:opacity-90"
            >
              Hire Us
            </button>
          </div>
        </div>

        {/* RIGHT IMAGE STACK */}
        <div className="grid h-full place-items-center">
          <div className="relative grid grid-cols-2 grid-rows-3">
            <img
              variants={popIn}
              transition={{ delay: 0.4 }}
              src="/images/wobbledrocket.png"
              alt=""
              className="hidden lg:block absolute -top-12 right-[30%] w-24 h-24"
            />
            <img
              variants={item}
              transition={{ delay: 0.3 }}
              src="/images/hero-image-7.jpg"
              alt="a male community member at an event"
              loading="lazy"
              className="relative z-10 object-cover col-span-1 col-start-1 row-start-1 row-end-3 ml-2 shadow-md w-3xs xl:w-80 h-80 xl:h-96 rounded-2xl shadow-accent"
            />
            <img
              variants={item}
              transition={{ delay: 0.4 }}
              src="/images/hero-image-5.jpg"
              alt="a male and a female community member talking while seated"
              loading="lazy"
              className="object-cover col-span-2 col-start-2 row-start-2 row-end-4 -ml-2 shadow-md w-3xs xl:w-80 h-80 xl:h-96 rounded-2xl shadow-accent"
            />
          </div>
        </div>

        <div
          variants={item}
          transition={{ delay: 0.6 }}
          className="flex flex-col items-center gap-4 -ml-3 md:-ml-4 md:flex-row lg:hidden text-center font-bold text-secondary"
        >
          <Link
            to="https://chat.whatsapp.com/GGDf21NCgcfA5R5z3hRBrv"
            className="w-[70vw] xs:w-[70vw] md:w-auto px-4 py-2 xs:px-6 xs:py-3 bg-primary rounded-full hover:opacity-90 focus:outline focus:outline-primary text-sm xs:text-base"
          >
            Join the Community
          </Link>

          <button
            onClick={() => handleNavClick("/#hireUs")}
            className="w-[70vw] xs:w-[70vw] md:w-auto px-4 py-2 xs:px-6 xs:py-3 bg-primary rounded-full hover:opacity-90 focus:outline focus:outline-primary text-sm xs:text-base"            >
            Hire Us
          </button>
        </div>

      </div>
    </section>
  );
}
